import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../../../styles/styles-css-variables";
import React from "react";
import { CSS_MQ } from "../../../../styles/breakpoints";
import { SwarovskiLink } from "../../../_shared-components/ui-elements/SwarovskiLink";
import { FONTS } from "../../../../styles/fonts";
import { ExpandedStoryTeaser } from "../../../../layouts/stories/stories-overview-page/stories-overview-page-layout";
import { SimpleAspectRatio } from "../../../_shared-components/SimpleAspectRatio";
import { ImageWithFocalPoint } from "../../../_shared-components/image-related/ImageWithFocalPoint";
import { EXPERIMENTAL_TextWithProductNameRenderer } from "../../../../domain/swarovski-optik/products/product-name/product-name-renderer";
import { T } from "../../../T";

export const StoriesOverviewBigTeaser: ReactTFC<{
  teaser: ExpandedStoryTeaser;
  shouldStretchText?: boolean;
}> = ({ teaser, shouldStretchText }) => {
  return (
    <React.Fragment>
      <SwarovskiLink
        link={teaser.link}
        attachStyles={css`
          display: flex;
          text-decoration: none;
          ${CSS_MQ.atLeastLg} {
            grid-area: 1 / 1 / span 2 / span 2;
          }

          --aspect-ratio: 9/16;
        `}
        isInternal={true}
        scrollToTop={true}
      >
        <SimpleAspectRatio
          css={css`
            width: 100%;
          `}
        >
          <ImageWithFocalPoint
            requestedWidth={800}
            focalPoint={teaser.imageWithFocalPoint.focalPoint}
            image={teaser.imageWithFocalPoint.image}
            attachStyles={css`
              width: 100%;
              height: 100%;
            `}
            assetId={teaser.imageWithFocalPoint.image.sys.id}
          />
        </SimpleAspectRatio>
      </SwarovskiLink>

      <SwarovskiLink
        link={teaser.link}
        attachStyles={css`
          display: block;
          text-decoration: none;
          margin-top: 20px;
          ${CSS_MQ.atLeastLg} {
            grid-area: ${shouldStretchText ? "3 / 1 / span 1 / span 2" : "3 / 1 / span 1 / span 1"};
          }
        `}
        isInternal={true}
        scrollToTop={true}
      >
        <h2
          css={css`
            ${FONTS.SwarovskiFutura500};
            font-size: 16px;
            color: ${CSS_COLORS.Black};
            letter-spacing: 1px;
            text-transform: uppercase;
            margin-top: 0;
            margin-bottom: 8px;
          `}
        >
          <EXPERIMENTAL_TextWithProductNameRenderer text={teaser.seoHeadline} />
        </h2>
        <h3
          css={css`
            ${FONTS.MinervaModern500};
            font-size: 24px;
            line-height: 28px;
            color: ${CSS_COLORS.Green};
            letter-spacing: 1.5px;
            text-transform: uppercase;
            margin-top: 0;
            margin-bottom: 15px;
          `}
        >
          <EXPERIMENTAL_TextWithProductNameRenderer text={teaser.emoHeadline} />
        </h3>
      </SwarovskiLink>
      <div
        css={css`
          grid-area: 4 / 1 / span 1 / span 1;
        `}
      >
        <div
          css={css`
            display: flex;
            flex-wrap: wrap;
          `}
        >
          {teaser.tags.map((t, idx) => (
            <SwarovskiLink
              isInternal={true}
              expectSimilarLayout={true}
              scrollToTop={true}
              link={t.expandedLink}
              attachStyles={css`
                color: ${CSS_COLORS.Black};
                margin-right: 5px;
                padding-right: 5px;
                font-weight: 500;
                line-height: 1;
                border-right: 1px solid ${CSS_COLORS.Black};
                &:last-child {
                  border-right: none;
                }
              `}
              key={idx}
            >
              {t.label}
            </SwarovskiLink>
          ))}
        </div>
        <p
          className={"u-fw-300"}
          css={css`
            color: rgba(0, 0, 0, 0.9);
            margin-top: 8px;
            font-size: 16px;
            line-height: 1;
            margin-bottom: 0;
          `}
        >
          <T>{teaser.readingTime}</T>
        </p>
      </div>
    </React.Fragment>
  );
};
